/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../../utils/logger')('splitio-engine:matcher');

function greaterThanEqualMatcherContext(ruleAttr /*: number */) /*: Function */{
  return function greaterThanEqualMatcher(runtimeAttr /*: number */) /*: boolean */{
    var isGreaterEqualThan = runtimeAttr >= ruleAttr;

    log.debug('[greaterThanEqualMatcher] is ' + runtimeAttr + ' greater than ' + ruleAttr + '? ' + isGreaterEqualThan);

    return isGreaterEqualThan;
  };
}

module.exports = greaterThanEqualMatcherContext;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/engine/matchers/gte.js
// module id = 450
// module chunks = 11